<div class="surveyjs-viewer">
  <survey [model]="surveyModel"></survey>
</div>
